import { RootState } from "../../redux-store";
import { FeatureName } from "dora-contracts";
import { createSelector } from "@reduxjs/toolkit";

const selectFeaturesState = (state: RootState) => state?.features;

export const selectFeature = (feature: FeatureName) =>
  createSelector(
    selectFeaturesState,
    (st) => st?.features[feature]?.enabled || false
  );

export const selectFeaturesInitialLoaded = createSelector(
  selectFeaturesState,
  (st) => st?.initialLoad
);
